import { render, staticRenderFns } from "./twoActivity.vue?vue&type=template&id=b957a324&scoped=true&"
import script from "./twoActivity.vue?vue&type=script&lang=js&"
export * from "./twoActivity.vue?vue&type=script&lang=js&"
import style0 from "./twoActivity.vue?vue&type=style&index=0&id=b957a324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b957a324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b957a324')) {
      api.createRecord('b957a324', component.options)
    } else {
      api.reload('b957a324', component.options)
    }
    module.hot.accept("./twoActivity.vue?vue&type=template&id=b957a324&scoped=true&", function () {
      api.rerender('b957a324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/child/twoActivity.vue"
export default component.exports